/*
 * gramms LP1 — FAQ reveal.
 *
 * <details>/<summary> keeps the semantics: keyboard, screen readers, and a
 * perfectly usable panel with JS disabled. This file only smooths the motion.
 *
 * Driven by the Web Animations API rather than a CSS transition. A click
 * mid-flight cancels the running animation and re-targets from the height the
 * panel is actually at, so hammering the summary stays in sync instead of
 * queueing up or stalling. Every run owns a token; only the newest one is
 * allowed to write the resting state back.
 */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  var EASING = 'cubic-bezier(0.25, 1, 0.5, 1)'; /* easeOutQuart */
  /* Tuned so a short answer snaps open and a long one still has some travel:
     ~190ms up to 240px of panel, easing out to 360ms for the tallest. */
  var MIN_DURATION = 190;
  var MAX_DURATION = 360;
  var MS_PER_PIXEL = 0.8;

  function durationFor(distance) {
    return Math.min(MAX_DURATION, Math.max(MIN_DURATION, distance * MS_PER_PIXEL));
  }

  function bind(item) {
    var summary = item.querySelector('summary');
    var reveal = item.querySelector('.lp1-faq__reveal');
    var answer = item.querySelector('.lp1-faq__answer');
    if (!summary || !reveal || !answer) return;

    /* Intent is tracked apart from `item.open`, because while closing the
       element has to stay open until the animation lands. */
    var intent = item.open ? 'open' : 'closed';
    var running = null;
    var fade = null;
    var token = 0;

    function settle() {
      reveal.style.height = '';
      reveal.style.overflow = '';
      answer.style.opacity = '';
      answer.style.transform = '';
      if (intent === 'closed') item.open = false;
    }

    /* The panel's resting height, measured rather than taken from
       scrollHeight: these blocks use text-box-trim, and scrollHeight reports
       the untrimmed line box, which overshoots by several pixels and made the
       panel collapse at the end of the animation. */
    function naturalHeight() {
      var previous = reveal.style.height;
      reveal.style.height = 'auto';
      var value = reveal.getBoundingClientRect().height;
      reveal.style.height = previous;
      return value;
    }

    summary.addEventListener('click', function (event) {
      if (reduce.matches) return; /* let <details> toggle natively */
      event.preventDefault();

      var opening = intent !== 'open';
      intent = opening ? 'open' : 'closed';

      /* A closed <details> keeps its content under content-visibility:hidden,
         and getBoundingClientRect then reports the LAST known height rather
         than 0. Reading it blindly made an opening panel jump straight to its
         full size and only animate the final few pixels. Only trust the rect
         while the panel is actually rendered. */
      var from = item.open ? reveal.getBoundingClientRect().height : 0;
      var fromOpacity = running ? Number(getComputedStyle(answer).opacity) : (opening ? 0 : 1);

      if (running) { running.cancel(); running = null; }
      if (fade) { fade.cancel(); fade = null; }

      if (opening) item.open = true;

      reveal.style.overflow = 'hidden';
      reveal.style.height = from + 'px';
      var to = opening ? naturalHeight() : 0;

      if (to === from) {
        settle();
        return;
      }

      var mine = ++token;
      var duration = durationFor(Math.abs(to - from));

      var animation = reveal.animate(
        [{ height: from + 'px' }, { height: to + 'px' }],
        { duration: duration, easing: EASING }
      );

      /* The copy slides the last few pixels in as it fades, which is what
         keeps the reveal from reading as a hard wipe. The inline styles hold
         the end state so the animation needs no fill mode to persist. */
      answer.style.opacity = opening ? '1' : '0';
      answer.style.transform = 'translateY(' + (opening ? 0 : -6) + 'px)';

      fade = answer.animate(
        [
          { opacity: fromOpacity, transform: 'translateY(' + (opening ? -6 : 0) + 'px)' },
          { opacity: opening ? 1 : 0, transform: 'translateY(' + (opening ? 0 : -6) + 'px)' }
        ],
        { duration: duration, easing: EASING }
      );

      running = animation;

      /* onfinish does not fire on cancel, and the token guards against a
         superseded run writing a stale resting state. */
      animation.onfinish = function () {
        if (mine !== token) return;
        running = null;
        fade = null;
        settle();
      };
    });
  }

  function setup(root) {
    if (!root || root.dataset.lp1FaqReady === 'true') return;
    root.dataset.lp1FaqReady = 'true';
    Array.prototype.forEach.call(root.querySelectorAll('.lp1-faq__item'), bind);
  }

  function setupAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-lp1-faq]'), setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setupAll(); });
  } else {
    setupAll();
  }

  document.addEventListener('shopify:section:load', function (event) { setupAll(event.target); });
})();
